import { Controller, useFormContext } from "react-hook-form";
import { Slider, SliderProps } from "./slider";

export type ControlledSliderProps = Omit<SliderProps, "onChange" | "value"> & {
  name: string;
};

export function ControlledSlider({ name, ...props }: ControlledSliderProps) {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      defaultValue={props?.defaultValue}
      name={name}
      render={({ field }) => {
        return (
          <Slider
            {...props}
            value={field.value}
            onChange={(value) => {
              field.onChange(value);
            }}
          />
        );
      }}
    />
  );
}
